<template>
  <div>
    <v-card>
      <v-toolbar
        color="transparent"
        flat
        dense
        tabs
        card
      >
        <v-toolbar-title>
          <h4>{{ $t('Addresses') }}</h4>
        </v-toolbar-title>
        <v-spacer />
        <v-btn
          flat
          class="text--secondary text-capitalize"
          @click="$emit('create')"
        >
          {{ $t('Add new address') }}
        </v-btn>
      </v-toolbar>
      <v-divider />
      <v-list
        subheader
        dense
        two-line
        class="pa-0"
      >
        <v-divider />
        <template v-for="(address, i) in addresses">
          <v-list-tile
            :key="i"
            @click="$emit('edit', address)"
          >
            <v-list-tile-action>
              <v-icon color="primary">
                location_on
              </v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ address.address_line1 }}</v-list-tile-title>
              <v-list-tile-sub-title>
                {{ addressState(address) }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <div>
                <v-icon
                  v-if="address.is_default"
                  left
                  color="primary"
                  class="mr-1"
                >
                  star
                </v-icon>
              </div>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider :key="`d-${i}`" />
        </template>
      </v-list>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'CustomerAddressList',

  props: {
    addresses: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    addressState () {
      return address =>
        `${address.locality}, ${address.administrative_area} ${address.postal_code}`
    }
  }
}
</script>
